import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const ButtonHoverAnimation = () => {
    const btnsRef = useRef([]);
    const btns2Ref = useRef([]);
    const gradients = useRef([]);
    const gradients2 = useRef([]);

    useEffect(() => {
        const btns = document.querySelectorAll('.btn');
        const btns2 = document.querySelectorAll('.btnHover2');

        btnsRef.current = btns;
        btns2Ref.current = btns2;

        const applyGradients = () => {
            btns.forEach((btn, index) => {
                btn.style.backgroundImage = `linear-gradient(${gradients.current[index]?.deg}deg, rgba(117,251,253,0.4) 0%, rgba(117,251,253,0.4) 30%, rgba(33,33,33,1) 50%, rgba(33,33,33,1) 100%)`;
            });
            btns2.forEach((btn, index) => {
                btn.style.backgroundImage = `linear-gradient(${gradients2.current[index]?.deg}deg, rgba(117,251,253,0.4) 0%, rgba(117,251,253,0.4) 30%, rgba(33,33,33,1) 50%, rgba(33,33,33,1) 100%)`;
            });
        };

        btns.forEach((btn, index) => {
            gradients.current[index] = { deg: 173 };
            btn.addEventListener('mouseover', () => {
                gsap.to(gradients.current[index], {
                    deg: 380,
                    duration: 0.6,
                    ease: 'ease.inOut',
                    onUpdate: applyGradients,
                });
            });
            btn.addEventListener('mouseout', () => {
                gsap.to(gradients.current[index], {
                    deg: 173,
                    duration: 0.6,
                    ease: 'ease.inOut',
                    onUpdate: applyGradients,
                });
            });
        });

        btns2.forEach((btn, index) => {
            gradients2.current[index] = { deg: 90 };
            btn.addEventListener('mouseover', () => {
                gsap.to(gradients2.current[index], {
                    deg: 300,
                    duration: 0.6,
                    ease: 'ease.inOut',
                    onUpdate: applyGradients,
                });
            });
            btn.addEventListener('mouseout', () => {
                gsap.to(gradients2.current[index], {
                    deg: 90,
                    duration: 0.6,
                    ease: 'ease.inOut',
                    onUpdate: applyGradients,
                });
            });
        });
    }, []);

    return null;
};

export default ButtonHoverAnimation;